import React, { useState, useEffect } from "react";
import { FaSearch, FaFilter } from "react-icons/fa";
import { getPartners } from "../../interpreter/partner";
import { getPartnerCompanies } from "../../interpreter/partner";

const PartnerFilter = ({ setPartners, onSearch }) => {
  const [searchData, setSearchData] = useState({
    partnerCompanyId: "",
  });
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      const data = await getPartnerCompanies(true);
      setCompanies(data || []);
    };
    fetchCompanies();
  }, []);

  const handleInputChange = (e) => {
    setSearchData({ ...searchData, [e.target.name]: e.target.value });
  };

  const handleSearch = async () => {
    try {
      const partnerCompanyId = searchData.partnerCompanyId?.trim() || null;
      const data = await getPartners(partnerCompanyId);
      setPartners(Array.isArray(data) ? data : []);
      onSearch?.(data);
    } catch (error) {
      console.error("Error al obtener partners:", error);
      setPartners([]);
    }
  };

  return (
    <div className="bg-white p-4 shadow-md rounded-lg mb-4 w-full">
      <h3 className="text-lg font-semibold mb-2 text-left">Buscador</h3>
      <div className="flex items-center gap-2 flex-wrap">
        <select
          name="partnerCompanyId"
          value={searchData.partnerCompanyId}
          onChange={handleInputChange}
          className="border p-2 rounded h-10 flex-grow min-w-[200px] text-sm sm:text-base bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-300"
        >
          <option value="">Todas las empresas</option>
          {companies.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white rounded hover:bg-blue-500 flex items-center gap-2 px-4 py-2 h-10"
        >
          <FaSearch size={15} /> Buscar
        </button>
      </div>
    </div>
  );
};

export default PartnerFilter;
